import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';

import SubAbasPdps from './SubAbasPdps';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { useFasePDP } from '../../../../services/enum/useFasePDP';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { usePlataformaPDP } from '../../../../services/enum/usePlataformaPDP';
import { useStatusPDP } from '../../../../services/enum/useStatusPDP';
import { useStatusPublicacaoPDP } from '../../../../services/enum/useStatusPublicacaoPDP';
import { useStatusVigenciaPDP } from '../../../../services/enum/useStatusVigenciaPDP';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import {
  getPdp,
  getProdutosDoPdp,
} from '../../../../services/produtosDAF/pdpService';
import { getProdutoDAFSimples } from '../../../../services/produtosDAF/produtosDafService';
import {
  clearAllCache,
  formataNomeMeioSiglas,
  formatarCnpj,
} from '../../../../utils/functions';
import {
  swal,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
  swalAttention,
} from '../../../../utils/swal';

//DADOS USUARIO
const user = getUser();
const userID = user.sub;
//const entity = ENTITY.ENTITY_Contratos;

export default function PdpFicha() {
  const CACHE_KEY = 'cachedPDPs';
  //PERMISSOES-MODULOS
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();

  //Enums
  const statusVigenciaPDP = useStatusVigenciaPDP();
  const statusPublicacaoPDP = useStatusPublicacaoPDP();
  const statusPDP = useStatusPDP();
  const plataformaPDP = usePlataformaPDP();
  const fasePDP = useFasePDP();

  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find((modulo) => modulo.label === 'Contratos')
      ?.value || '0',
  );

  // Verificar permissões para ações
  // const canDownload = isActionAllowed(MODULO, 'read', papelUsuarioOptions);
  //const canInsert = isActionAllowed(MODULO, 'create', papelUsuarioOptions);
  const canDelete = isActionAllowed(MODULO, 'delete', papelUsuarioOptions);
  const canSave = isActionAllowed(MODULO, 'update', papelUsuarioOptions);
  //PERMISSOES

  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  //Dados do componente
  let logs = {};
  let subAbas = [];

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formPdp, setFormPdp] = useState({
    usuarioId: userID,
    id: 0,
    statusPublicacao: 0,
    statusVigencia: 0,
    statusPdp: 0,
    plataforma: 0,
    faseAtual: 0,
    idPdp: '',
    dataPublicacao: '',
    dataInicioFaseII: '',
    dataInicioFaseIII: '',
    termoCompromisso: '',
    demanda: '',
    instituicaoPublica: '',
    instituicaoPublicaCNPJ: '',
    parceiroPrivadoNacional: '',
    parceiroPrivadoNacionalCNPJ: '',
    parceiroPrivadoInternacional: '',
    parceiroPrivadoInternacionalCNPJ: '',
    entidadeIfa: '',
    entidadeIfaCNPJ: '',
    observacoes: '',
  });

  type ProdutoDaPdp = {
    usuarioId: number;
    produtoDAFId: number;
    produtoDAF: string;
    pdpId: number;
    observacoes: string;
  };
  const [produtosDaPdp, setProdutosDaPdp] = useState<ProdutoDaPdp[]>([
    {
      usuarioId: 0,
      produtoDAFId: 0,
      produtoDAF: '',
      pdpId: 0,
      observacoes: '',
    },
  ]);

  const [formPdpInicial, setFormPdpInicial] = useState<typeof formPdp | null>(
    null,
  );
  const [produtosDaPdpInicial, setProdutosDaPdpInicial] = useState<
    ProdutoDaPdp[] | null
  >(null);

  //Buscar dados
  // Estado para armazenar a lista de produtos e o estado de carregamento
  type ProdutoOption = {
    value: number;
    label: string;
  };
  const [listaProdutosDAF, setListaProdutosDAF] = useState<ProdutoOption[]>([]); // Ajustado para o tipo { value, label }

  useEffect(() => {
    const fetchDataProdutosDaf = async () => {
      try {
        const produtos = await getProdutoDAFSimples();

        // Transforma os dados em formato { value, label } e adiciona "Não informado"
        const produtosFormatados: ProdutoOption[] = [
          { value: 0, label: 'Não informado' }, // Primeira opção padrão
          ...produtos.map((produto: any) => ({
            value: produto.id,
            label: produto.produtoFarmaceutico,
          })),
        ];

        setListaProdutosDAF(produtosFormatados); // Define a lista de produtos no estado com o tipo correto
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataProdutosDaf(); // Chama a função para buscar os dados
  }, []);

  const fetchData = async (id: string) => {
    try {
      const registroData = await getPdp(id);
      setLogData(registroData);
      const formPdpAtual = {
        id: registroData.id,
        usuarioId: userID,
        statusPublicacao: registroData.statusPublicacao,
        statusVigencia: registroData.statusVigencia,
        statusPdp: registroData.statusPdp,
        plataforma: registroData.plataforma,
        faseAtual: registroData.faseAtual,
        idPdp: registroData.idPdp,
        dataPublicacao: registroData.dataPublicacao,
        dataInicioFaseII: registroData.dataInicioFaseII,
        dataInicioFaseIII: registroData.dataInicioFaseIII,
        termoCompromisso: registroData.termoCompromisso,
        demanda: registroData.demanda,
        instituicaoPublica: registroData.instituicaoPublica,
        instituicaoPublicaCNPJ: registroData.instituicaoPublicaCNPJ,
        parceiroPrivadoNacional: registroData.parceiroPrivadoNacional,
        parceiroPrivadoNacionalCNPJ: registroData.parceiroPrivadoNacionalCNPJ,
        parceiroPrivadoInternacional: registroData.parceiroPrivadoInternacional,
        parceiroPrivadoInternacionalCNPJ:
          registroData.parceiroPrivadoInternacionalCNPJ,
        entidadeIfa: registroData.entidadeIfa,
        entidadeIfaCNPJ: registroData.entidadeIfaCNPJ,
        observacoes: registroData.observacoes,
      };

      setFormPdp(formPdpAtual);
      setFormPdpInicial(formPdpAtual);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }

    try {
      const produtosDaPdpData = await getProdutosDoPdp(id);

      // Atualizar o estado dos produtos do kit com valores formatados
      const produtosFormatados = produtosDaPdpData.map((produto: any) => ({
        usuarioId: userID,
        produtoDAFId: produto.produtoDAF.id,
        produtoDAF: produto.produtoDAF.produtoFarmaceutico,
        pdpId: formPdp.id,
        observacoes: produto.observacoes || 'Nenhuma observação específica.',
      }));
      setProdutosDaPdp(produtosFormatados);

      setProdutosDaPdpInicial(produtosFormatados); // Salvar o estado inicial dos produtos
      setLinhas(produtosFormatados.map((_: any, index: number) => index));
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  const [statusPublicacaoStyle, setStatusPublicacaoStyle] =
    useState<React.CSSProperties>({});
  const [statusVigenciaStyle, setStatusVigenciaStyle] =
    useState<React.CSSProperties>({});
  const [statusAtivoStyle, setStatusAtivoStyle] = useState<React.CSSProperties>(
    {},
  );
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const amarelo = '#faffb4dd';

    const statusPublicacao =
      statusPublicacaoPDP[formPdp.statusPublicacao]?.label || '-';
    const newStatusPublicacaoStyle = {
      backgroundColor:
        statusPublicacao === 'Não Publicado'
          ? vermelho
          : statusPublicacao === 'Publicado'
            ? verde
            : 'white',
    };
    setStatusPublicacaoStyle(newStatusPublicacaoStyle);

    const statusVigencia =
      statusVigenciaPDP[formPdp.statusVigencia]?.label || '-';
    const newStatusVigenciaStyle = {
      backgroundColor:
        statusVigencia === 'Extinta'
          ? vermelho
          : statusVigencia === 'Vigente'
            ? verde
            : 'white',
    };
    setStatusVigenciaStyle(newStatusVigenciaStyle);

    const statusAtivo = statusPDP[formPdp.statusPdp]?.label || '-';
    const newStatusPDPStyle = {
      backgroundColor:
        statusAtivo === 'Ativa'
          ? verde
          : statusAtivo === 'Suspensa'
            ? amarelo
            : 'white',
    };
    setStatusAtivoStyle(newStatusPDPStyle);
  }, [formPdp.statusPublicacao, formPdp.statusVigencia, formPdp.statusPdp]);

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasPdps(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/produtosdaf/pdps/ficha/dadosgerais`,
      },
    ];
  }

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;

    const novoValor = name.includes('CNPJ') ? formatarCnpj(value) : value;

    setFormPdp((prevState) => ({
      ...prevState,
      [name]: novoValor,
    }));
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.dataPublicacao) {
      errors.push('<b>Publicação Site</b> é obrigatório.');
    }

    if (!form.statusVigencia) {
      errors.push('<b>Status da Vigência</b> é obrigatório.');
    }

    if (!form.statusPdp) {
      errors.push('<b>Status Ativo</b> é obrigatório.');
    }

    if (!form.faseAtual) {
      errors.push('<b>SFase Atual</b> é obrigatório.');
    }

    if (!form.plataforma) {
      errors.push('<b>Plataforma</b> é obrigatório.');
    }

    if (!form.demanda) {
      errors.push('<b>Demanda</b> é obrigatório.');
    }

    if (!form.termoCompromisso) {
      errors.push('<b>Termo de Compromisso</b> é obrigatório.');
    }

    if (!form.instituicaoPublica) {
      errors.push('<b>Instituição Pública</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const adjustFormBeforeSubmit = (formPdp: any) => {
    return {
      ...formPdp,
      // Adicione ajustes necessários aqui
      statusPublicacao: Number(formPdp.statusPublicacao),
      statusVigencia: Number(formPdp.statusVigencia),
      statusPdp: Number(formPdp.statusPdp),
      faseAtual: Number(formPdp.faseAtual),
      plataforma: Number(formPdp.plataforma),
      demanda: Number(formPdp.demanda),
      dataPublicacao: formPdp.dataPublicacao ? formPdp.dataPublicacao : null,
      dataInicioFaseII: formPdp.dataInicioFaseII
        ? formPdp.dataInicioFaseII
        : null,
      dataInicioFaseIII: formPdp.dataInicioFaseII
        ? formPdp.dataInicioFaseII
        : null,
      observacoes: formPdp.observacoes || 'Nenhuma observação específica.',
    };
  };

  const handleCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formPdp);
      if (!isFormValid) return;

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormBeforeSubmit(formPdp);

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(`/api/produtopdp/`, adjustedForm);
      clearAllCache(CACHE_KEY);
      setTimeout(
        () =>
          (window.location.href = `#/daf/produtosdaf/pdps/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formPdp);
      if (!isFormValid) return;

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormBeforeSubmit(formPdp);

      const response = await httpClient.patch(
        `/api/produtopdp/${fichaID}`,
        adjustedForm,
      );
      clearAllCache(CACHE_KEY);
      fetchData(response.data.registro.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await httpClient.delete(`/api/notaversaosisaf/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/maisopcoes/notas');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  //////////////////////Produtos

  const handleChangeProduto = (
    event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
    index: number,
  ) => {
    const { value } = event.target;
    const produtoSelecionado = listaProdutosDAF.find(
      (produto) => produto.value === parseInt(value, 10),
    );

    if (!produtoSelecionado) {
      return; // Caso nenhum produto seja encontrado, não faça nada
    }

    // Verificar se o produto já foi selecionado em outra linha (excluindo a linha atual)
    const produtoJaSelecionado = produtosDaPdp.some(
      (produto, idx) =>
        produto.produtoDAFId === produtoSelecionado.value && idx !== index,
    );

    if (produtoJaSelecionado) {
      // Se o produto já foi selecionado, exibir um erro e não fazer a atualização
      swalErro('Este produto já foi selecionado em outra linha.');
      return;
    }

    // Se não houver problema, prosseguir com a atualização
    const updatedProdutos = [...produtosDaPdp];
    updatedProdutos[index] = {
      ...updatedProdutos[index],
      produtoDAFId: produtoSelecionado.value, // Atualiza o ID do produto selecionado
      produtoDAF: produtoSelecionado.label,
      pdpId: formPdp.id,
    };
    setProdutosDaPdp(updatedProdutos);
  };

  const [linhas, setLinhas] = useState([0]);
  const handleInserirProduto = () => {
    setLinhas((prevLinhas) => [...prevLinhas, prevLinhas.length]);
    setProdutosDaPdp((prevProdutos) => [
      ...prevProdutos,
      {
        usuarioId: userID,
        produtoDAFId: 0,
        produtoDAF: '',
        pdpId: formPdp.id,
        observacoes: '',
      },
    ]);
  };

  const handleRemoverProduto = () => {
    if (linhas.length > 1) {
      // Remover a última linha e atualizar os produtos
      setLinhas((prevLinhas) => prevLinhas.slice(0, -1));
      setProdutosDaPdp((prevProdutos) => prevProdutos.slice(0, -1));
    } else {
      swalErro(
        'Não é possível remover. Pelo menos um produto deve estar presente.',
      );
    }
  };

  const handleSalvarProdutos = async () => {
    // Ajustar o formulário antes de enviar para o backend
    const adjustedForm = produtosDaPdp.map((produto) => ({
      ...produto, // mantém todos os campos originais
      pdpId: Number(fichaID), // garante que está certo e numérico
      observacoes: produto.observacoes || 'Nenhuma observação específica.',
    }));

    // const token = 'JWT_SECRET';

    await httpClient.post(`/api/produtopdprl/`, adjustedForm);
    clearAllCache(CACHE_KEY);
  };

  // Função para definir qual ação de salvar deve ser tomada
  const definirFuncaoSalvar = async () => {
    let houveMudancaPdp = false;
    let houveMudancaProdutos = false;

    for (const key in formPdp) {
      const typedKey = key as keyof typeof formPdp;
      if (formPdp[typedKey] !== formPdpInicial?.[typedKey]) {
        console.log(`Campo diferente: ${typedKey}`);
        console.log('formPdp:', formPdp[typedKey]);
        console.log('formPdpInicial:', formPdpInicial?.[typedKey]);
      }
    }

    // Verificar se houve mudanças no form do kit
    if (formPdpInicial) {
      houveMudancaPdp =
        formPdp.idPdp !== formPdpInicial.idPdp ||
        formPdp.observacoes !== formPdpInicial.observacoes ||
        formPdp.statusPdp !== formPdpInicial.statusPdp ||
        formPdp.statusVigencia !== formPdpInicial.statusVigencia ||
        formPdp.plataforma !== formPdpInicial.plataforma ||
        formPdp.faseAtual !== formPdpInicial.faseAtual ||
        formPdp.dataPublicacao !== formPdpInicial.dataPublicacao ||
        formPdp.dataInicioFaseII !== formPdpInicial.dataInicioFaseII ||
        formPdp.dataInicioFaseIII !== formPdpInicial.dataInicioFaseIII ||
        formPdp.termoCompromisso !== formPdpInicial.termoCompromisso ||
        formPdp.demanda !== formPdpInicial.demanda ||
        formPdp.instituicaoPublica !== formPdpInicial.instituicaoPublica ||
        formPdp.instituicaoPublicaCNPJ !==
          formPdpInicial.instituicaoPublicaCNPJ ||
        formPdp.parceiroPrivadoNacional !==
          formPdpInicial.parceiroPrivadoNacional ||
        formPdp.parceiroPrivadoNacionalCNPJ !==
          formPdpInicial.parceiroPrivadoNacionalCNPJ ||
        formPdp.parceiroPrivadoInternacional !==
          formPdpInicial.parceiroPrivadoInternacional ||
        formPdp.parceiroPrivadoInternacionalCNPJ !==
          formPdpInicial.parceiroPrivadoInternacionalCNPJ ||
        formPdp.entidadeIfa !== formPdpInicial.entidadeIfa ||
        formPdp.entidadeIfaCNPJ !== formPdpInicial.entidadeIfaCNPJ;
    } else {
      houveMudancaPdp = true;
    }

    // Verificar se houve mudanças nos produtos do kit
    if (produtosDaPdpInicial) {
      if (produtosDaPdpInicial.length !== produtosDaPdp.length) {
        houveMudancaProdutos = true;
      } else {
        for (let i = 0; i < produtosDaPdpInicial.length; i++) {
          if (
            produtosDaPdpInicial[i].produtoDAFId !==
              produtosDaPdp[i].produtoDAFId ||
            produtosDaPdpInicial[i].observacoes !== produtosDaPdp[i].observacoes
          ) {
            houveMudancaProdutos = true;
            break;
          }
        }
      }
    } else {
      // Se produtosDoKitInicial é null, significa que são novos produtos
      houveMudancaProdutos = true;
    }

    if (!houveMudancaPdp && !houveMudancaProdutos) {
      swalAttention('Não houve mudanças!');
      return;
    }

    // 1. Atualizar o Kit se houver mudanças
    if (houveMudancaPdp) {
      if (formPdpInicial && formPdpInicial.id !== 0) {
        await handleUpdate();
      } else {
        await handleCreate();
      }

      // Atualizar o estado inicial do Kit após salvar
      setFormPdpInicial({ ...formPdp });
    }

    // 2. Atualizar os produtos do Kit apenas se houver mudanças e o Kit já existir
    if (houveMudancaProdutos && formPdp.id !== 0) {
      await handleSalvarProdutos();

      // Atualizar o estado inicial dos produtos após salvar
      const copiaProdutos = produtosDaPdp.map((p) => ({ ...p }));
      setProdutosDaPdpInicial(copiaProdutos);
      // Resetar o estado de verificação
    }

    if (houveMudancaPdp || houveMudancaProdutos) {
      swalSave();
      houveMudancaPdp = false;
      houveMudancaProdutos = false;
    }
  };

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/produtosdaf/pdps"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} />

          {/* Dados da PDP */}
          <BoxConteudo boxTitulo="Dados da PDP">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="200px">
                <SelectInput
                  name="statusPublicacao"
                  options={statusPublicacaoPDP}
                  label="Status Publicação"
                  value={formPdp.statusPublicacao}
                  onChange={handleChange}
                  style={statusPublicacaoStyle}
                  required
                />
              </CustomCol>
              <CustomCol
                width="200px"
                helpText="Data de publicação da PDP no site."
              >
                <Input
                  name="dataPublicacao"
                  label="Publicação Site"
                  value={formPdp.dataPublicacao}
                  id="dataPublicacao"
                  onChange={handleChange}
                  type="date"
                  required
                />
              </CustomCol>
              <CustomCol width="120px">
                <Input
                  name="idPdp"
                  label="ID da PDP"
                  value={formPdp.idPdp}
                  id="idPdp"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>

              <CustomCol>
                <SelectInput
                  name="statusVigencia"
                  options={statusVigenciaPDP}
                  label="Vigência"
                  value={formPdp.statusVigencia}
                  onChange={handleChange}
                  style={statusVigenciaStyle}
                  required
                />
              </CustomCol>
              <CustomCol>
                <SelectInput
                  name="statusPdp"
                  options={statusPDP}
                  label="Status PDP"
                  value={formPdp.statusPdp}
                  style={statusAtivoStyle}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol>
                <SelectInput
                  name="faseAtual"
                  options={fasePDP}
                  label="Fase Atual"
                  value={formPdp.faseAtual}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="dataInicioFaseII"
                  label="Início Fase II"
                  value={formPdp.dataInicioFaseII}
                  id="dataInicioFaseII"
                  onChange={handleChange}
                  type="date"
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="dataInicioFaseIII"
                  label="Início Fase III"
                  value={formPdp.dataInicioFaseIII}
                  id="dataInicioFaseIII"
                  onChange={handleChange}
                  type="date"
                />
              </CustomCol>
            </CustomRow>

            {/* Termo de Compromisso */}
            <CustomRow>
              <CustomCol width="250px">
                <SelectInput
                  name="plataforma"
                  options={plataformaPDP}
                  label="Plataforma"
                  value={formPdp.plataforma}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="150px">
                <Input
                  name="demanda"
                  label="Demanda %"
                  value={formPdp.demanda}
                  id="demanda"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  type="number"
                  required
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="termoCompromisso"
                  label="Termo de Compromisso"
                  value={formPdp.termoCompromisso}
                  id="termoCompromisso"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {/* Indústrias participantes */}
          <BoxConteudo boxTitulo="Instituições e indústrias participantes">
            {/* Instituição Pública */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="instituicaoPublica"
                  label="Instituição Pública"
                  value={formPdp.instituicaoPublica}
                  id="instituicaoPublica"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="250px">
                <Input
                  name="instituicaoPublicaCNPJ"
                  label="CNPJ"
                  value={formPdp.instituicaoPublicaCNPJ}
                  id="instituicaoPublicaCNPJ"
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
            {/* Parceiro Privado Nacional */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="parceiroPrivadoNacional"
                  label="Parceiro Privado Nacional"
                  value={formPdp.parceiroPrivadoNacional}
                  id="parceiroPrivadoNacional"
                  onChange={handleChange}
                />
              </CustomCol>

              <CustomCol width="250px">
                <Input
                  name="parceiroPrivadoNacionalCNPJ"
                  label="CNPJ"
                  value={formPdp.parceiroPrivadoNacionalCNPJ}
                  id="parceiroPrivadoNacionalCNPJ"
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
            {/* Parceiro Privado Internacional */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="parceiroPrivadoInternacional"
                  label="Parceiro Privado Internacional"
                  value={formPdp.parceiroPrivadoInternacional}
                  id="parceiroPrivadoInternacional"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="250px">
                <Input
                  name="parceiroPrivadoInternacionalCNPJ"
                  label="CNPJ"
                  value={formPdp.parceiroPrivadoInternacionalCNPJ}
                  id="parceiroPrivadoInternacionalCNPJ"
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
            {/* Entidade Privada IFA Base Química  */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="entidadeIfa"
                  label="Entidade Privada IFA Base Química "
                  value={formPdp.entidadeIfa}
                  id="entidadeIfa"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="250px">
                <Input
                  name="entidadeIfaCNPJ"
                  label="CNPJ"
                  value={formPdp.entidadeIfaCNPJ}
                  id="entidadeIfaCNPJ"
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {/* Produtos */}
          <BoxConteudo boxTitulo="Produtos da PDP">
            {produtosDaPdp.map((produto, index) => (
              <CustomRow key={index}>
                <CustomCol width="100px">
                  <Input
                    id={`idProduto-${index}`}
                    name={`idProduto-${index}`}
                    label={`ID ${index + 1}`}
                    value={produto.produtoDAFId || ''}
                    onChange={(e) => handleChangeProduto(e, index)}
                    onClick={() => {
                      if (produto.produtoDAFId) {
                        const novaUrl = `${window.location.origin}/#/daf/produtosdaf/produtos/ficha/${produto.produtoDAFId}/dadosgerais`;
                        window.open(novaUrl, '_blank');
                      }
                    }}
                    style={{
                      color: 'blue',
                      textDecoration: 'underline',
                      cursor: produto.produtoDAFId ? 'pointer' : 'default',
                    }}
                    readonly
                  />
                </CustomCol>
                <CustomCol>
                  <SelectInput
                    name={`produtoDAF-${index}`}
                    options={listaProdutosDAF}
                    label={`Produto Farmacêutico ${index + 1}`}
                    value={produto.produtoDAFId || ''}
                    onChange={(e) => handleChangeProduto(e, index)}
                  />
                </CustomCol>
              </CustomRow>
            ))}
            <CustomRow style={{ display: 'flex', justifyContent: 'flex-end' }}>
              {fichaID === 'undefined' ? (
                <WorkspaceBotoes inserir inserirDisabled={true} />
              ) : (
                <WorkspaceBotoes
                  inserir
                  onClickInserir={handleInserirProduto}
                  remover
                  onClickRemover={handleRemoverProduto}
                />
              )}
            </CustomRow>
          </BoxConteudo>

          {/* Observações */}
          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formPdp.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            deleteDisabled={!canDelete}
            onClickDelete={handleDelete}
            save
            saveDisabled={!canSave}
            onClickSave={definirFuncaoSalvar}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={definirFuncaoSalvar} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
